export function convertToFormData(obj: any, formData = new FormData(), parentKey = ""): FormData {
  if (obj === null || obj === undefined) {
    return formData;
  }

  if (obj instanceof File) {
    formData.append(parentKey, obj, obj.name);
  } else if (Array.isArray(obj)) {
    obj.forEach((item, index) => {
      convertToFormData(item, formData, `${parentKey}[${index}]`);
    });
  } else if (typeof obj === "object") {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key];
        const newParentKey = parentKey ? `${parentKey}.${key}` : key;
        convertToFormData(value, formData, newParentKey);
      }
    }
  } else {
    formData.append(parentKey, obj.toString());
  }

  return formData;
}
